export enum APPLICATION_ENDPOINTS {
  ACCOUNT_SETTINGS = '/patient-service/resources/accounts/settings',
  ACTIVATE_NEW_ACCOUNT = '/patient-service/resources/accounts/activate',
  NEW_ACCOUNT_FROM_WEB_LABORATORY = '/patient-service/resources/accounts/user-web-laboratory',
  REACTIVATE_ACCOUNT = '/patient-service/resources/accounts/reactivate',
  ALLPPARAMETER_URL = 'patient-service/resources/function-parameters',
  APPOINTMENT_DETAIL = '/patient-service/resources/patients/:patientId/appointments/:appointmentType/:nrSeq',
  CANCEL_AGENDA = '/patient-service/resources/patients/:patientId/appointments/:nrSeqAgenda/cancel',
  CHECK_CAN_CANCEL_AGENDA = '/patient-service/resources/patients/:patientId/appointments/:ieScheduleType/:nrSeqAgenda/check-can-cancel',
  CHECK_FOR_CREATE_REVISION_PERSONAL_DATA_NOTIFICATIONS = '/patient-service/resources/patients/:patientId/notification/fetchrevnotifications',
  CHECK_PRIVACY = '/patient-service/resources/privacy/check',
  CHECK_TERMS_OF_USE = '/patient-service/resources/terms-of-use/check/type/:termType',
  CREATE_NEW_ACCOUNT = '/patient-service/resources/accounts',
  NEW_ACCOUNT_CHECK_USERNAME = '/patient-service/resources/accounts/check-username',
  CHECK_REPLACEMENT_LOGIN = '/patient-service/resources/accounts/check-replacement-login',
  EMAILSMSSENDER_RECOVEREMAILSMS = '/patient-service/resources/reset-password/request',
  RESEND_REQUEST_PASSWORD_SMS = '/patient-service/resources/reset-password/sms/resend?dsLogin=:dsLogin',
  EMAILSENDER_SUCCESS_MAIL = '/patient-service/resources/reset-password/validate-reset-password/token/:token',
  RESET_PASSWORD_BY_SMS = '/patient-service/resources/reset-password/sms/:smsCode/reset',
  FORGET_PASSWORD_MAIL = '/patient-service/resources/users/password-reset-request',
  GET_CONFIGURATION = '/patient-service/resources/configuration',
  GET_CAPTCHA_KEY_CONFIGURATION = '/patient-service/resources/configuration/captcha-key',
  GET_LOCALE_AND_LANGUAGE = '/patient-service/resources/locale',
  GET_LOGIN_TYPE_PARAM = '/patient-service/resources/login-type-param/:functionCode/:functionParameter',
  GET_PRIVACY_SEQUENCE = '/patient-service/resources/privacy/sequence',
  GET_TERMS_OF_USE_SEQUENCE = '/patient-service/resources/terms-of-use/sequence/type/:termType',
  NEW_APPOINTMENT_ESTABLISHMENT_LOCALE = '/patient-service/resources/appointments/establishment-group-localization-list',
  NEW_APPOINTMENT_MEDICAL_AREA_LIST = '/patient-service/resources/appointments/medical-activity-area-list/medical-activity-name-list',
  CANCEL_WAITING_LIST_ITEM = '/patient-service/resources/appointments/:patientId/waiting-list/:nrSequenceWaitingList',
  UPDATE_STATUS_APPOINTMENT = '/patient-service/resources/appointments/update-status-appointment',
  NEW_APPOINTMENT_PATIENT = '/patient-service/resources/appointments/patients-list',
  PACS_LINK_GENERATION = '/patient-service/resources/patients/:patientId/pacsintegration/link',
  PACS_STATE = '/patient-service/resources/patients/pacsintegration/state',
  POST_ALTER_PASSWORD = '/patient-service/resources/alter-password',
  POST_NOTIFICACAO_ATUALIZAR_CADASTRO = '/patient-service/resources/dummy/patient/auth',
  POST_PROFILE_UPDATE_INSURANCE = '/patient-service/resources/profile/update-data/insurances/patient/:patientCode',
  POST_PROFILE_CREATE_INSURANCE = '/patient-service/resources/profile/create-data/insurances/:patientId',
  GET_PHYSICAL_PERSON_DATA_WITH_PHOTO = '/patient-service/resources/profile',
  POST_RENEW_PASSWORD = '/patient-service/resources/renew-password',
  GET_VALIDATE_RESET_PASSWORD_TOKEN = '/patient-service/resources/reset-password/validate-hash-token/token/:token',
  RESET_PASSWORD = '/patient-service/resources/reset-password',
  REVOKE = '/patient-service/resources/logout',
  SEND_SCHEDULE_ICS_EMAIL = '/patient-service/resources/patients/:patientId/appointments/:ieScheduleType/:nrSeqAgenda/send-mail-ics-calendar',
  STEP_1_GET_USER = '/patient-service/resources/appointments/patients-list',
  TEST_GET_PATIENT_INFO = '/patient-service/resources/dummy/patient/:patientId',
  UPCOMING_APPOINTMENTS_LIST = '/patient-service/resources/patients/:patientId/appointments/list/',
  GET_WAITING_LIST_ITEMS = '/patient-service/resources/patients/:patientId/appointments/list/waiting-list',
  UPDATE_PRIVACY = '/patient-service/resources/privacy/confirm',
  UPDATE_TERMS_OF_USE = '/patient-service/resources/terms-of-use/:nrSeqTermo',
  USERS_LOCALE_ENDPOINT = 'patient-service/resources/users/locale',
  INFORMATION = '/patient-service/resources/dashboard/information',
  GET_FIELDS_REQUIRE_PROOF = '/patient-service/resources/profile/field-required-proof',
  UPLOAD_PERSON_DOCUMENTS = '/patient-service/resources/files/person/upload',
  SAVE_PERSON_DOCUMENTS_INFO_DB = '/patient-service/resources/person-documents/add',

  //Profile
  POST_PROFILE_INFORMATION = '/patient-service/resources/profile/update-data/patient/:patientId',
  POST_ALTERNATIVE_LOGIN = '/patient-service/resources/profile/update-data/alternative-login/patient/:patientId',
  GET_ALTERNATIVE_LOGIN = '/patient-service/resources/profile/alternative-login/patient/:patientCode',

  //Insurance
  ACCOUNT_CREATION_VALIDATOR = '/patient-service/resources/accounts/validate?fields=:fields',
  DEFAULT_INSURANCE = '/patient-service/resources/patient/:cdPessoaFisica/insurance/patient-insurance',
  INSURANCE_CATEGORY_LIST = '/patient-service/resources/patient/insurance/:cdConvenio/category',
  INSURANCE_LIST = '/patient-service/resources/patient/insurance/list-insurance',
  INSURANCE_PLAN_LIST = '/patient-service/resources/patient/insurance/:cdConvenio/plan/:cdCategoria',
  MY_INSURANCES = '/patient-service/resources/patient/insurance/my-insurances',
  CHECK_INSURANCE_ELIGIBILITY = '/patient-service/resources/integration/insurance/check-eligibility',
  UPDATE_INSURANCE_CARD = '/patient-service/resources/patient/insurance/update-vat/:cardId',
  PARTICULAR_INSURANCE = '/patient-service/resources/patient/insurance/get-particular-insurance',
  PROFILE_DEPENDENTS_LIST = '/patient-service/resources/dependents',

  // Appointments
  POST_PATIENT_QUESTIONS = '/patient-service/resources/appointments/patient/:patientId/patient-questions',
  RETRIEVE_PATIENT_QUESTIONS = '/patient-service/resources/appointments/patient/:nrSeqPrepPacient/patient-questions',
  GET_IS_ASK_TO_PHYSICIAN_TASK_REGISTERED = '/patient-service/resources/appointments/ask-to-physician-task',

  //New-Appointment
  GET_PHYSCIAN = '/patient-service/resources/appointments/physician-list/physician-name-list',
  GET_PREVIOUS_SEQ_AGENDA_INTEGRADA = '/patient-service/resources/new-appointments/:patientId/has-seq-agenda-integrada',
  GET_SEQ_AGENDA_INTEGRADA = '/patient-service/resources/new-appointments/:patientId/seq-agenda-integrada',
  GET_SEQ_PROC_INTERNO = '/patient-service/resources/new-appointments/:patientId/seq-proc-interno/:nrSeqAgeint',
  SCHEDULE_CONFIRM = '/patient-service/resources/new-appointments/:patientId/confirm-and-request/:nrSeqAgeint',
  CHECKUP_CONFIRM = '/patient-service/resources/new-appointments/:patientId/confirm-checkup/:checkupSequence',
  SUGGESTION_DATES = '/patient-service/resources/new-appointments/:patientId/get-suggest-times/:nrSeqAgeint',
  AVAILABLE_CALENDAR_DAY = '/patient-service/resources/new-appointments/:patientId/get-suggest-times/:nrSeqAgeint/get-available-calendar-days',
  TASY_MEDICAL_AREA_PARAMETER = '/patient-service/resources/new-appointments/tasyParameter/medical-area',
  TIME_RESERVATION = '/patient-service/resources/new-appointments/:patientId/time-reservation',
  DESIRED_DATE = '/patient-service/resources/new-appointments/desired-date',
  CLEAR_TIME_RESERVATION = '/patient-service/resources/new-appointments/:patientId/clear-time-reservation',
  GET_NEW_APPOINTMENT_SCHEDULE_CONFIG = '/patient-service/resources/new-appointments/get-new-appointment-schedule-config',
  GET_WSUITE_SCHEDULE_CONFIG = '/patient-service/resources/new-appointments/get-wsuite-schedule-config',
  GET_WSUITE_CUSTOM_MESSAGE = '/patient-service/resources/new-appointments/get-wsuite-custom-message',
  GET_WSUITE_CUSTOM_MESSAGE_UPLOAD_CREATION_ACCOUNT = '/patient-service/resources/configuration/get-wsuite-custom-message-upload-creation-account',
  GET_MY_INSURANCES_DATA_CARD='/patient-service/resources/patient/insurance/my-insurances/card-data/:patientId',
  GET_QUIZ_METADATA = '/patient-service/resources/new-appointments/quiz-metadata/:seqAgeInt',
  PUT_QUIZ_ITEM = '/patient-service/resources/new-appointments/update-answer-quiz-item/:nrSeqAgeint',
  QUIZ_AVAILABLE = '/patient-service/resources/new-appointments/tasy/quiz-available',
  GET_VISIBILITY_OF_FIELDS = '/patient-service/resources/visibility-of-fields',
  GET_PHYSICIAN_NAME_BY_MD_CODE = '/patient-service/resources/appointments/physician-name',
  ADD_PHYSICIAN_NAME_TO_SCHEDULE = '/patient-service/resources/appointments/physician-name/add',
  APPOINTMENT_DOCUMENT_UPLOAD_RULE = '/patient-service/resources/new-appointments/document-upload-rule/:insurance',
  UPLOAD_APPOINTMENT_DOCUMENTS = '/patient-service/resources/new-appointments/upload-documents/temp',
  CREATE_APPOINTMENT_DOCUMENTS = '/patient-service/resources/new-appointments/create-uploaded-files/:integratedScheduleId',
  GET_SCHEDULE_INSTRUCTIONS = '/patient-service/resources/schedules/appointments/generateReport',

  //Reschedule-Appointment
  RESCHEDULE_ITEMS_TRANSFERENCE = '/patient-service/resources/reschedule-appointments/:patientId/transfer-items',
  CONSULTATION_PHYSICIAN_AND_SPECIALITY = '/patient-service/resources/reschedule-appointments/:patientId/consultation-physician-and-speciality/:nrSeqAgeint',
  TASY_RESCHEDULE_PARAMETERS = '/patient-service/resources/reschedule-appointments/tasy-parameter/reschedule',
  HEALTH_INSURANCE_BY_NR_SEQ_AGEINT = '/patient-service/resources/reschedule-appointments/:patientId/health-insurance-id/:nrSeqAgeint',

  //Notifications
  NOTIFICATION_COUNT_URL = '/patient-service/resources/patients/:patientId/notification/count?paramLabExam=:paramLabExam&paramPatExam=:paramPatExam&paramRadExam=:paramRadExam',
  NOTIFICATION_LIST_URL = '/patient-service/resources/patients/:patientId/notification/list?paramLabExam=:paramLabExam&paramRadExam=:paramRadExam&paramPatExam=:paramPatExam',
  NOTIFICATION_UPDATE_STATUS_READ = '/patient-service/resources/patients/:patientId/notification/markread',
  NOTIFICATION_DELETE = '/patient-service/resources/patients/:patientId/notification?notificationId=:notificationId',
  NOTIFICATION_UPDATE_STATUS_VIEW = '/patient-service/resources/patients/:patientId/notification/markview',
  NOTIFICATION_UPDATE_STATUS_UNREAD = '/patient-service/resources/patients/:patientId/notification/mark-unread',
  NOTIFICATION_UPDATE_ALL_TO_VIEWED = '/patient-service/resources/patients/:patientId/notification/mark-all-as-viewed',
  NOTIFICATION_UPDATE_ALL_TO_READ = '/patient-service/resources/patients/:patientId/notification/mark-all-as-read',

  //Acount
  IS_EMAIL_VALID = '/patient-service/resources/accounts/validate-email',
  POST_CLOSE_ACCOUNT = '/patient-service/resources/account-closure/',
  RESEND_ACTIVATION_MAIL = '/patient-service/resources/accounts/resend-activation-email',
  RESEND_ACTIVATION_MAIL_BY_USERNAME = '/patient-service/resources/accounts//user/resend-activation-email',
  CREATE_NEW_USER_AVAILABLE = '/patient-service/resources/accounts/create-new-user-available',
  DOCUMENT_UPLOAD_RULE = '/patient-service/resources/accounts/document-upload-rule/:stage',
  UPLOAD_DOCUMENTS = '/patient-service/resources/accounts/upload/temp',

  //Account - sms
  RESEND_SMS_CODE = '/patient-service/resources/accounts/resend-activation-sms',
  CONFIRM_SMS_CODE = '/patient-service/resources/accounts/validate-sms-code/:smsCode',
  VALIDATE_SMS_CODE = '/patient-service/resources/reset-password/sms/:smsCode',

  APPOINTMENT_PERIOD_COUNT = '/patient-service/resources/patients/:patientId/appointments/date/list/?initialDate=:startDate&finalDate=:endDate',

  //LGPD
  FUNCTION_ACESS_LOG = '/patient-service/resources/audit/function-access',
  FILTER_EXECUTED_LOG = '/patient-service/resources/audit/filter-executed',

  // Configuration
  SCHEDULING_CONFIGURATION = '/patient-service/resources/scheduling-configuration/get-scheduling-display-rules',
  ALLOWED_SCHEDULING = '/patient-service/resources/scheduling-configuration/get-allowed-scheduling',
  NEW_SCHEDULING_ALLOWED = '/patient-service/resources/scheduling-configuration/new-scheduling-allowed',

  // Dashboard
  SCHEDULING_ACTIVE = '/patient-service/resources/dashboard/scheduling-available',
  EXAMS_RESULT_AVAILABLE = '/patient-service/resources/dashboard/exams-result-available',
  WAITING_LIST= '/patient-service/resources/dashboard/waiting-list',

  // Exams
  GET_EXAM_DATE_FROM_FILTER = '/patient-service/resources/exams/datefrom',
  GET_EXAM_DETAILS = '/patient-service/resources/patient/:patientId/exams/details',
  GET_EXAM_LIST = '/patient-service/resources/patient/:patientId/exams/examresults',
  GET_EXAMS_LAB_LIST = '/patient-service/resources/patient/:patientId/exams/lab/detailslist/physician/:cdMedico/:dtProcedimento/status/:status',
  POST_EXAM_REPORT_MAIL = '/patient-service/resources/patient/:patientId/exams/report/sendreportmail',
  POST_REPORT_CONTENT = '/patient-service/resources/patient/:patientId/exams/report/generate',
  POST_UPDATE_VIEW_EXAM = '/patient-service/resources/patient/:patientId/exams/update-view-exam?ieTipoItem=:ieTipoItem&nrPrescricao=:nrPrescricao&nrSequencia=:nrSequencia',
  FILE_VIEW_REPORT_CONTENT = '/patient-service/resources/temp/preview',
  TEST_GET_PATIENT_EXAMS = '/patient-service/resources/dummy/patient/:patientId/exams',
  GET_EXAM_AVAILABLE_LIST = '/patient-service/resources/patient/:patientId/exams/lab/detailslist/physician/:cdMedico/:dtProcedimento/status/A',
  GET_EXAM_PROCESSING_LIST = '/patient-service/resources/patient/:patientId/exams/lab/detailslist/physician/:cdMedico/:dtProcedimento/status/P',

  // Landing Page
  GET_LANDING_PAGE_ITEMS = '/patient-service/resources/landing-page/items',

  // Waiting List
  POST_WAITING_LIST = '/patient-service/resources/waiting-list/enter-list',
  GET_LAST_POSITION_BY_LOGIN = '/patient-service/resources/waiting-list/last-login-position',
  PUT_WAITING_LIST_CANCEL_DATE = '/patient-service/resources/waiting-list/cancel-date',
  GET_WAITING_LIST_DETAIL = '/patient-service/resources/waiting-list/details',
  GET_WAITING_LIST_QUESTIONAIRE = '/patient-service/resources/waiting-list/questionaire-info',

  // Questionnaire
  GET_QUESTIONAIRE_METADATA = '/patient-service/resources/questionnaire/:nrSeqAvaliacao',

  // My Chart
  GET_MC_ALLERGIES = '/cci-platform-mychart-ms/allergies/person/:patientId',
  POST_MC_ALLERGIES = '/cci-platform-mychart-ms/allergies/person/:patientId',
  PUT_DISABLE_MC_ALLERGIES = '/cci-platform-mychart-ms/allergies/allergie/:sequence/disable',
  DELETE_MC_ALLERGIES = '/cci-platform-mychart-ms/allergies/allergie/:allergieId',
  PUT_RELEASE_MC_ALLERGIES = '/cci-platform-mychart-ms/allergies/allergie/:allergieId/release',
  GET_MC_ALLERGIE_DETAIL = '/cci-platform-mychart-ms/allergies/person/:patientId/allergie-detail',
  GET_MC_ALLERGIE_AUTOCOMPLETE = '/patient-service/resources/my-chart/patients/allergieType',
  GET_MC_HOSPITAL_VISUALIZATION = '/cci-platform-mychart-ms/allergies/hospital-visualization',
  GET_MC_MEDICAL_DATA_REPORT = '/patient-service/resources/my-chart/patients/:patientId/medical-data/:type/report/:nrSequence',
  GET_MC_MEDICAL_DATA_REPORT_AVAILABILITY = '/patient-service/resources/my-chart/patients/:patientId/medical-data/:type/report/availability',
  GET_MC_MEDICINE_DETAIL = '/patient-service/resources/my-chart/patients/:patientId/medicine-detail/:nrSequence',
  GET_MC_SENDING_DOCUMENTS_INFO = '/cci-platform-mychart-ms/sending-documents/patient/:patientId/local-delivery/:localDelivery',
  GET_MC_SENDING_DOCUMENTS_DOCUMENT_TYPE = '/cci-platform-mychart-ms/sending-documents/document-types',
  POST_MC_SENDING_DOCUMENTS = '/patient-service/resources/my-chart/patients/:patientId/sending-documents',
  PUT_MC_READ_DOCUMENT = '/patient-service/resources/my-chart/patients/:patientId/documents/read-document',
  POST_MC_READ_DOCUMENT_MICROSSERVICE = '/cci-platform-mychart-ms/document-summary',
  GET_MC_ITENS_TO_SHOW = '/cci-platform-mychart-ms/menu-items',
  GET_MC_HOSPITAL_ITENS_TO_SHOW = '/cci-platform-mychart-ms/menu-items/hospital-tab-item/:myChartItem',
  POST_MC_HOSPITAL_ITENS_AS_READ = '/cci-platform-mychart-ms/menu-items/hospital-tab-item/:myChartItem/record/:recordSequence',
  GET_MC_SUMMARY_DETAIL_DATA_REPORT = '/patient-service/resources/my-chart/summary/detail/person/:patientId/report',
  GET_MC_SUMMARY_DETAIL_UNIFIED_REPORT = '/patient-service/resources/my-chart/summary/:encounterId/person/:patientId/unified-report',
  POST_MC_SUMMARY_REPORT_EMAIL = '/patient-service/resources/my-chart/summary/person/:patientId/mail/report',
  POST_MC_SUMMARY_UNIFIED_REPORT_EMAIL = '/patient-service/resources/my-chart/summary/:encounterId/person/:patientId/mail/unified-report',
  GET_MC_SUMMARY_CONFIG = '/cci-platform-mychart-ms/summary/config',
  GET_MC_PAST_HISTORY_HOSPITAL_DETAIL = '/cci-platform-mychart-ms/past-history/hospital/person/:patientId/pastHistory/:pastHistorySequence',
  GET_MC_PAST_HISTORY_PATIENT_DETAIL = '/cci-platform-mychart-ms/past-history/person/:patientId/pastHistory/:pastHistorySequence',
  POST_MC_PAST_HISTORY = '/cci-platform-mychart-ms/past-history/person/:patientId',
  POST_MC_PAST_HISTORY_INACTIVATE = '/cci-platform-mychart-ms/past-history/person/:patientId/inactivate',
  POST_MC_PAST_HISTORY_RELEASE = '/cci-platform-mychart-ms/past-history/person/:patientId/release',
  POST_MC_PAST_HISTORY_READ_DOCUMENT = '/cci-platform-mychart-ms/past-history/document-past-history',
  GET_MC_VACCINE_DETAIL = '/cci-platform-mychart-ms/vaccines/person/:patientId/vaccine/:sequence/detail',
  GET_MC_VACCINE_DETAIL_DATA_REPORT = '/patient-service/resources/my-chart/vaccines/detail/person/:patientId/report',
  POST_MC_VACCINE_READ_DOCUMENT = '/cci-platform-mychart-ms/vaccines/document-vaccine',
  POST_MC_VACCINE_EMAIL = '/patient-service/resources/my-chart/vaccines/person/:patientId/mail',
  GET_MC_MEDICINE = '/cci-platform-mychart-ms/medicament/person/:patientId',
  GET_MC_MEDICINE_HOSPITAL_DETAIL = '/cci-platform-mychart-ms/medicament/hospital/person/:patientId/medicament/:medicamentSequence',
  GET_MC_MEDICINE_PATIENT_DETAIL = '/cci-platform-mychart-ms/medicament/person/:patientId/medicament/:medicamentSequence',
  POST_MC_MEDICINE = '/cci-platform-mychart-ms/medicament/person/:patientId',
  POST_MC_MEDICINE_INACTIVATE = '/cci-platform-mychart-ms/medicament/person/:patientId/inactivate',
  POST_MC_MEDICINE_RELEASE = '/cci-platform-mychart-ms/medicament/person/:patientId/release',
  POST_MC_MEDICINE_READ_DOCUMENT = '/cci-platform-mychart-ms/medicament/document-medicament',
  POST_MC_SEND_DOCUMENT =  '/cci-platform-mychart-ms/sending-document/person/:patientId',
  DELETE_MC_PAST_HISTORY = '/cci-platform-mychart-ms/past-history/person/:patientId/past-history/:pastHistorySequence',
  DELETE_MC_MEDICINE = '/cci-platform-mychart-ms/medicament/:medicamentSequence',
  GET_TELECONSULTATION_RECORDS = '/cci-platform-mychart-ms/telehealth/patient/:patientCode/telehealth-records',
  GET_MC_TELECONSULTATION_REPORT = '/patient-service/resources/my-chart/chat-room/:roomCode/telehealth-chat-report',

  // Files
  GET_FILES_RULES = '/patient-service/resources/files/rules',
  GET_STORAGE_FILE = '/patient-service/resources/temp/preview-storage',

  //TELEMEDICINE
  GET_URL_TELEMEDICINE = '/patient-service/resources/telemedicine/patient/:patientId/tokeinize/:nrSeqAgendaConsulta',

  // Questionnaire
  POST_MED_PATIENT_EVALUATION = '/patient-service/resources/questionnaire/evaluation/:nrSeqAvaliacao/med-patient-evaluation/:patientId',
  POST_SATISFACTION_RESEARCH = '/patient-service/resources/questionnaire/satisfaction-research/:nrSeqAvaliacao/patient/:patientId',
  GET_EVALUATION = '/patient-service/resources/questionnaire/schedule/:nrSeqAgendamento/evaluation/dynamic-form/:code',
  GET_SATISFACTION_RESEARCH = '/patient-service/resources/questionnaire/schedule/:nrSeqAgendamento/satisfaction-research/dynamic-form/:code',

  // Forget Password
  POST_RECOVERY_DATA = '/patient-service/resources/reset-password/get-recovery-data',

  // Physician
  GET_PHYSICIAN_IMAGE = '/patient-service/resources/physicians/:nrSequenceImg/image',

  //authentication
  AUTHENTICATION = '/patient-service/resources/authentication',
  GET_AUTHENTICATION_CLIENT_STATUS  = '/patient-service/resources/authentication/security-authentication/client/status',
  GET_AUTHENTICATION_STATUS  = '/patient-service/resources/authentication/status',
  PUT_REQUEST_AUTHENTICATION = '/patient-service/resources/authentication/request-activation-mfa',
  PUT_VALIDATE_AUTHENTICATION = '/patient-service/resources/authentication/validate-activation-mfa',
  PUT_DEACTIVATE_AUTHENTICATION = '/patient-service/resources/authentication/deactivate-authentication-mfa',

  // Tasks
  UPDATE_TASK_STATUS = '/patient-service/resources/task/update-task-status/:nrSequencia?taskType=:taskType',
  GET_TASK_LIST = '/patient-service/resources/task/patient/:patientId/task-list?eventType=:eventType',
  GET_SCHEDULE_TASKS_PROGRESS = '/patient-service/resources/task/patient/:patientId/schedule-tasks-progress',
  POST_TASKS_SENDING_DOCUMENTS = '/patient-service/resources/task/patients/:patientId/sending-documents',

  // Public Appointment
  PUBLIC_UPDATE_APPOINTMENT_STATUS = '/patient-service/resources/public-appointments/type/:type/:token',

  // Addres Fields
  GET_ADDRESS_FIELDS = '/patient-service/resources/address/catalog/:nrSeqCatalog',

  // Online Payment
  GET_PAYMENT_DATA_REPORT = '/patient-service/resources/online-payment/detail/person/:patientId/report',

  // Quiz Question Anwser
  GET_QUIZ_ANWSER_METADATA = '/patient-service/resources/new-appointments/quiz-answer-metadata/:seqAgeInt',

  //Checkup
  GET_CHECKUP_DETAIL = '/patient-service/resources/checkup/:checkupSequence/detail',
  GET_CHECKUP_SCHEDULE_CONFIG = '/patient-service/resources/new-appointments/get-checkup-schedule-config',
  GET_SCHEDULE_LOCATION = '/patient-service/resources/checkup/schedule-location',
  GET_CHECKUP_LIST = '/cci-platform-integrated-schedule-ms/schedule/myCompanion/checkup/get-checkup',
  POST_CONFIRM_CHECKUP = '/cci-platform-integrated-schedule-ms/schedule/myCompanion/checkup/confirm',
  POST_RESCHEDULE_CHECKUP = '/cci-platform-integrated-schedule-ms/schedule/myCompanion/checkup/reschedule',

}
